<script>
export const BANNERS = [
  // { id: '1', type: 'external', newsThumb: 'https://img.aandf.co.jp/aandfcojp/img/banner/line_sp_banner_2018_1.png', url: 'https://line.me/R/ti/p/%40hqn6779h', title: 'LINE 友だち追加すると、A&Fカントリー限定商品の入荷情報やお得なクーポン配信、お友達限定のプレゼントキャンペーンやイベント開催情報などをお届けします。' },
  { id: '1', type: 'external', newsThumb: 'https://img.aandf.co.jp/aandfcojp/img/banner/app_official.webp', url: 'https://yappli.plus/aandf_corporatebanner', title: 'エイアンドエフのいろんなこと。　このアプリひとつで。 エイアンドエフ公式アプリリリース！' },
  { id: '2', type: 'link', newsThumb: 'https://img.aandf.co.jp/aandfcojp/img/banner/hikuing_sp.jpg', url: '/news/release/news_release_2020_aandf_urayamakai_haikuing', title: '「第八回エイアンドエフ・ウラヤマ会 ハイ句イング大賞」を実施中です。' },
  // { id: '3', type: 'link', newsThumb: 'https://img.aandf.co.jp/aandfcojp/img/banner/haikugraphy_sp.jpg', url: '/news/release/news_release_2019_aandf_urayamakai_haikugraphy', title: 'ハイクグラフィー大賞コンテストが始まります。' },
]
</script>

<script setup>
import { onMounted } from 'vue'
import { Link } from '@inertiajs/inertia-vue3'
import usePreloadImages from '@/Shared/usePreloadImages.js'

const emit = defineEmits(['loaded'])

onMounted(() => {
  usePreloadImages({
    data: BANNERS,
    key: 'newsThumb',
    callback: function () {
      emit('loaded')
    },
  })
})

</script>

<template>
  <li v-for="banner in BANNERS" :key="banner.id" class="isotope-item hover-item">
    <Link v-if="banner.type === 'link'" :href="banner.url"><img :src="banner.newsThumb" :alt="banner.title" /></Link>
    <a v-else :href="banner.url" target="_blank"><img :src="banner.newsThumb" :alt="banner.title" /></a>
  </li>
</template>
